export class RastreamentoDetalhesReversaController {
  
}
